<template>
 <div></div>
</template>

<script type="text/javascript">

import { mapGetters  } from 'vuex'

export default {
    components: {},
    props: {},
    data() {
        return {}
    },
    methods: {
      ...mapGetters('rights', ['canQuery', 'canAdd', 'canEdit', 'canDelete', 'canImport', 'canExport']),
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    watch: {}
}
</script>

<style type="text/css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/template.vue